import React, { useState, useEffect } from "react";
import { Dialog } from "@headlessui/react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { envoyerRelanceFacture } from "../services/RelanceFactureService";

const RelanceFacturePopup = ({ isOpen, onClose, facture, defaultMessage, onSuccess }) => {
    const token = useSelector((state) => state.auth.token);

    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    // 🔄 Réinitialiser les champs à l'ouverture
    useEffect(() => {
        if (facture) {
            setSubject(`Relance de paiement - Facture ${facture.numero}`);
            setMessage(defaultMessage || "");
        }
    }, [facture, defaultMessage]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!facture) return;

        setLoading(true);
        try {
            const result = await envoyerRelanceFacture(facture.id, { subject, message }, token);

            if (result.success) {
                toast.success(result.message || `Relance envoyée à ${facture.client.email} avec succès !`);
                onSuccess && onSuccess();
                onClose();
            } else {
                toast.error(result.message || "Impossible d’envoyer la relance.");
            }
        } catch (err) {
            toast.error(err.message || "Erreur inconnue lors de l’envoi.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <Dialog open={isOpen} onClose={onClose} className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
            <div className="bg-white rounded-2xl shadow-lg p-6 w-full h-[80%] max-w-xl relative z-50 flex flex-col">
                <Dialog.Title className="text-lg font-bold text-gray-800 mb-4">
                    Nouvelle relance pour facture {facture?.numero}
                </Dialog.Title>

                <form onSubmit={handleSubmit} className="flex flex-col gap-4 flex-1">
                    {/* Sujet */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sujet</label>
                        <input
                            type="text"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            className="w-full border rounded-lg px-3 py-2 text-sm focus:ring focus:ring-color3"
                        />
                    </div>

                    {/* Message body qui prend tout l'espace */}
                    <div className="flex-1 flex flex-col">
                        <label className="block text-sm font-medium text-gray-700">Message</label>
                        <textarea
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            className="flex-1 w-full border rounded-lg px-3 py-2 text-sm focus:ring focus:ring-color3 resize-none"
                        />
                    </div>

                    {/* Boutons */}
                    <div className="flex justify-end gap-3 mt-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 rounded-lg border text-white bg-color16 text-sm"
                        >
                            Fermer
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="px-4 py-2 rounded-lg bg-color1 text-white hover:bg-color3 text-sm font-medium disabled:opacity-50"
                        >
                            {loading ? "Envoi..." : "Envoyer"}
                        </button>
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default RelanceFacturePopup;
